import { useState, useEffect } from "react";
import { NAV as TCC_NAV, TASKS, GUIDING_PRINCIPLES, SUCCESS_TARGETS, CHANGE_MGMT_STEPS, RESISTANCE_PATTERNS, SUMMIT_SESSIONS as TCC_SUMMIT_SESSIONS, DRAFT_MATERIALS_BASE, PROJECT_META as TCC_PROJECT_META } from "./projectConfig";
import useProjectConfig from "./useProjectConfig";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { OrgDirectoryProvider } from "./OrgDirectoryContext";
import DataAuditTab from "./DataAuditTab";
import ArchitectureTab from "./ArchitectureTab";
import OnboardingTracker from "./OnboardingTracker";
import ConsentForm from "./ConsentForm";
import AdminTab from "./AdminTab";
import AccelerationCapture from "./AccelerationCapture";
import usePermissions from "./usePermissions";
import BYPASS_USERS from "./bypassUsers";
import { PROJECT_PERMISSIONS as TCC_PROJECT_PERMISSIONS } from "./projectConfig";
import ProjectSelector from "./ProjectSelector";
import { SaveStatus } from "./SummitCaptureTabs";
import storyFrameworkCaptureConfig from "./tabConfigs/story-framework-capture.json";
import currentStateCaptureConfig from "./tabConfigs/current-state-capture.json";
import GenericCaptureRenderer from "./GenericCaptureRenderer";
import readinessCaptureConfig from "./tabConfigs/readiness-capture.json";
import useCaseCaptureConfig from "./tabConfigs/use-case-capture.json";
import dataPlatformDecisionsCaptureConfig from "./tabConfigs/data-platform-decisions-capture.json";
import pilotPlanningCaptureConfig from "./tabConfigs/pilot-planning-capture.json";
import governanceCaptureConfig from "./tabConfigs/governance-capture.json";
import executionCaptureConfig from "./tabConfigs/execution-capture.json";
import day1WrapCaptureConfig from "./tabConfigs/day1-wrap-capture.json";
import summitCloseCaptureConfig from "./tabConfigs/summit-close-capture.json";
import StatusTab from "./StatusTab";
import DocsSection from "./DocsSection";
import Footer from "./Footer";
import { fetchMetrics, fetchPlatformTracker, fetchSummitData } from "./platformService";

function LockedTab() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px", color: "#6b7280" }}>
      <div style={{ fontSize: 32, marginBottom: 16 }}>🔒</div>
      <div style={{ fontWeight: 700, fontSize: 16, color: "#1a1a2e", marginBottom: 8 }}>Sign in to view this content</div>
      <div style={{ fontSize: 13, color: "#6b7280" }}>Use your TCC Microsoft account to access this section.</div>
    </div>
  );
}

const C = {
  dark: "#1a1a2e", gold: "#c9a84c", white: "#fff", surface: "#f8f7f4",
  border: "#e5e7eb", muted: "#6b7280", text: "#374151",
  green: "#27ae60", orange: "#e67e22", red: "#c0392b",
  blue: "#2980b9", purple: "#8e44ad", yellow: "#fde68a", yellowBg: "#fef3c7",
};
















const SOURCES = [
  { system: "Bullhorn CRM/ATS", owner: "Martin / Multiple", futureOwner: "Vanessa", trust: "medium", stories: "All", action: "fix", priority: "P0" },
  { system: "Bullhorn Time and Expense", owner: "Multiple", futureOwner: "Cassie", trust: "low", stories: "Financial", action: "fix", priority: "P0" },
  { system: "Bullhorn Time and Labor", owner: "Multiple", futureOwner: "Cassie", trust: "low", stories: "Financial", action: "fix", priority: "P0" },
  { system: "Bullhorn Analytics", owner: "Multiple", futureOwner: "Vanessa", trust: "low", stories: "All", action: "fix", priority: "P0" },
  { system: "Bullhorn Pay and Bill", owner: "Multiple", futureOwner: "Clare", trust: "low", stories: "Financial", action: "fix", priority: "P0" },
  { system: "NetSuite", owner: "Sarah", futureOwner: "Sarah", trust: "high", stories: "Financial", action: "keep", priority: "P0" },
  { system: "Paycom Payroll", owner: "Lisa / Cassie", futureOwner: "Cassie", trust: "high", stories: "Employee Dev", action: "keep", priority: "P1" },
  { system: "Paycom HR", owner: "Lisa", futureOwner: "Rachel", trust: "high", stories: "Employee Dev", action: "keep", priority: "P1" },
  { system: "LinkedIn Recruiter", owner: "Kalynn", futureOwner: "Burke", trust: "high", stories: "Recruiter / Candidate", action: "keep", priority: "P1" },
  { system: "ZoomInfo", owner: "Samantha", futureOwner: "Monica", trust: "high", stories: "Client / Rep", action: "keep", priority: "P1" },
  { system: "Zoom", owner: "Sean", futureOwner: "Annae", trust: "high", stories: "Rep, Recruiter", action: "keep", priority: "P2" },
  { system: "RefAssure", owner: "Ops Team", futureOwner: "Monica", trust: "high", stories: "Candidate", action: "keep", priority: "P2" },
  { system: "Great Recruiters", owner: "Marketing", futureOwner: "Danielle", trust: "high", stories: "Recruiter", action: "keep", priority: "P2" },
  { system: "Intelagree", owner: "Contracts", futureOwner: "Rachel", trust: "medium", stories: "Client", action: "keep", priority: "P2" },
  { system: "Leadr", owner: "Desirae", futureOwner: "Desirae", trust: "n/a", stories: "Employee Dev (TBD)", action: "evaluate", priority: "P3" },
  { system: "VMS Sync", owner: "Sam and Clay", futureOwner: "Clay", trust: "medium", stories: "Automation", action: "keep", priority: "P1" },
  { system: "Power Automate / Forms", owner: "Martin", futureOwner: "TBD", trust: "medium", stories: "Automation", action: "keep", priority: "P2" },
  { system: "CData Connect AI", owner: "Kalynn", futureOwner: "TBD", trust: "low", stories: "Automation / AI", action: "replace", priority: "P1" },
  { system: "ChatGPT direct", owner: "Kalynn / Annae", futureOwner: "TBD", trust: "low", stories: "Multiple", action: "replace", priority: "P1" },
  { system: "Excel FP&A Model", owner: "Mike", futureOwner: "Mike", trust: "high", stories: "Financial", action: "migrate", priority: "P1" },
  { system: "Excel Monthly Ops Reporting", owner: "Taylor", futureOwner: "Vanessa", trust: "low", stories: "All", action: "replace", priority: "P0" },
  { system: "Excel UPT", owner: "Rachel", futureOwner: "Vanessa", trust: "high", stories: "Employee Dev, Rep, Recruiter", action: "migrate", priority: "P1" },
  { system: "Excel PO Burndowns", owner: "4 owners", futureOwner: "Chase", trust: "low", stories: "Client, Enterprise, Automation", action: "replace", priority: "P1" },
  { system: "Excel Weekly Billing", owner: "Amanda", futureOwner: "Amanda", trust: "high", stories: "Financial, Company", action: "migrate", priority: "P0" },
  { system: "Excel Master Billing Sheet", owner: "Sarah", futureOwner: "Sarah", trust: "high", stories: "Financial, Automation", action: "migrate", priority: "P0" },
  { system: "PowerBI Recruiter DB Report", owner: "Alexis", futureOwner: "Alexis", trust: "medium", stories: "Recruiter", action: "keep", priority: "P2" },
  { system: "PowerBI Enterprise SAE", owner: "Taylor", futureOwner: "Taylor", trust: "medium", stories: "Enterprise", action: "keep", priority: "P2" },
  { system: "Mercury", owner: "TBD", futureOwner: "TBD", trust: "n/a", stories: "TBD", action: "evaluate", priority: "P3" },
  { system: "VaaS Library / AWS GitHub", owner: "Jeff", futureOwner: "PJ?", trust: "n/a", stories: "VaaS", action: "evaluate", priority: "P3" },
];

const ARCH_LAYERS = [
  { layer: "Layer 1: Systems of Record", color: "#2980b9", desc: "Every source system is a read-only operational input. We extract from them. We do not report from them directly.", items: ["Bullhorn - operational source of truth", "NetSuite - financial source of truth", "Paycom - payroll and HR source of truth", "Intelagree - contract source of truth", "LinkedIn / ZoomInfo / SignalHire / RefAssure / Great Recruiters - enrichment only", "Zoom - phone and call data", "Power Automate / Forms / SharePoint - workflow and form data"] },
  { layer: "Layer 2: Integration Layer", color: "#27ae60", desc: "All data moves through a single managed integration layer. No CSV exports to Excel. No ad-hoc API calls. No direct database connections.", items: ["Managed ETL/ELT - Decision needed at summit: Fivetran vs Airbyte vs Azure Data Factory", "API Gateway for Microsoft stack sources", "Ingestion Validation: schema enforcement, duplicate detection, freshness checks", "All pipelines logged, monitored, and alertable"] },
  { layer: "Layer 3: Data Platform", color: "#c9a84c", desc: "The warehouse is the single source of truth. Every downstream tool reads from here.", items: ["Raw Landing Zone - immutable, time-stamped copies of every source payload", "Transformation Layer - dbt/SQL models producing clean, standardized data", "Curated Data Warehouse - Decision needed at summit: Snowflake vs BigQuery vs Microsoft Fabric", "Master Data Management - single entity definitions for Client, Contact, Candidate, Job, Worker", "Semantic Metrics Layer - every KPI defined once: Revenue, Spread, Starts, Fill Rate, Ks On, Billables"] },
  { layer: "Layer 4: Governance", color: "#8e44ad", desc: "Governance runs in parallel with every layer from Day 1.", items: ["Data Catalog - every field, every table, every owner documented", "Data Classification - PII, financial, operational, public", "Data Quality Scorecards - completeness, accuracy, freshness tracked weekly", "Lineage - every report traces back to source with full transformation history", "Role-Based Access Controls - enforced at warehouse and semantic layer", "Backup, Retention, and Recovery - defined SLAs per data domain"] },
  { layer: "Layer 5: Consumption", color: "#c0392b", desc: "Every tool reads from the Semantic Metrics Layer only. No direct warehouse access without going through the semantic layer.", items: ["BI Tool - Decision needed at summit: PowerBI vs QuickSight vs other", "Bullhorn Analytics - operational dashboards", "Cube - financial planning and forecasting connected to warehouse actuals", "Executive Storytelling - investor narrative, CIM-ready outputs", "AI / Intelligence Layer - Phase 4 only; governed access via API to semantic layer"] },
];

const AI_STRATEGY_PHASES = [
  { phase: "Phase 1-3 (Now - Q4 2026)", title: "Build the Foundation. No AI.", color: "#c0392b", items: ["Replace CData Connect AI with a governed API Gateway", "Classify all data domains - PII, financial, operational, public", "Build the Semantic Metrics Layer - single KPI definitions, machine-readable", "Establish role-based access controls at every data layer", "Document all data lineage"] },
  { phase: "Phase 4 - Pilot (Dec 2026)", title: "Agentic Day Planner - Flagship Pilot", color: "#8e44ad", items: ["Agentic overnight build - no user prompting required", "Delivered to Outlook every morning before the user starts their day", "Data signals: Bullhorn activity, open jobs, candidate pipeline, LinkedIn, ZoomInfo, Zoom recency", "Model weights signals by relevance - no manual configuration by user", "Pilot cohort: recruiter or sales rep team with cleanest Bullhorn data", "Success gate: 30-day pilot review before full rollout"] },
  { phase: "Phase 4 - Full Launch (Q1 2027+)", title: "AI Layer - Governed Access Only", color: "#27ae60", items: ["AI Intelligence Layer connects to Semantic Metrics Layer only", "Recruiter tools: candidate matching, pipeline prediction, DB quality scoring", "Rep tools: client expansion signals, account penetration analysis", "Executive tools: revenue forecasting, retention risk, EBITDA trajectory", "Operations: replace manual Excel reports with AI-assisted summaries backed by clean data"] },
  { phase: "CIM Readiness (Q2 2027)", title: "AI-Assisted Investor Narrative", color: "#8e44ad", items: ["Natural language querying against the semantic layer", "AI-assisted CIM development - all outputs traced to auditable source data", "Client review automation - enterprise account storytelling at scale", "Platform Business narrative proven by the data layer"] },
];

const AGENTIC_SIGNALS = [
  { source: "Bullhorn", color: "#2980b9", signals: ["Days since last touch per candidate", "Open job age and fill urgency", "Submission to interview conversion rate", "Placement pipeline by stage", "Overdue tasks and follow-ups", "Activity volume vs personal baseline"] },
  { source: "LinkedIn / ZoomInfo", color: "#0077b5", signals: ["Contact job change signals", "Company hiring surge indicators", "New decision maker in target account", "Competitor placement signals", "Account expansion triggers"] },
  { source: "Zoom / Call Data", color: "#27ae60", signals: ["Days since last call per key contact", "Call duration trends (engagement proxy)", "Contacts with no recent call (at-risk)", "Call frequency vs placement rate correlation"] },
  { source: "Open Jobs and Pipeline", color: "#c9a84c", signals: ["Jobs nearing close date with no submissions", "Hot jobs flagged by site lead or SAE", "Candidates in final stage needing follow-up", "Stale pipeline (no movement in 7+ days)"] },
];

const OWNERS = [
  { name: "Dan Frasco", role: "CIO - Data and AI Executive Lead", domains: ["Architecture", "Integration layer", "AI governance", "Data and AI strategy and execution"] },
  { name: "Vanessa Fucciani", role: "Business Intelligence", domains: ["Metric definitions", "Story frameworks", "Bullhorn Analytics", "Dashboard specs"] },
  { name: "Martin Lopez", role: "Systems / Engineering", domains: ["Platform build", "Bullhorn operations", "ETL build", "Power Automate", "VMS Sync"] },
  { name: "Mike Dansby", role: "Finance", domains: ["NetSuite", "FP&A models", "Financial story", "Cube / forecasting"] },
  { name: "Rachel Hopper", role: "HR / Operations - Change Management Lead", domains: ["Paycom HR", "Intelagree", "Employee Dev story", "UPT", "Change management and adoption"] },
  { name: "Dave Smith", role: "Executive Sponsor - Data and AI Vision", domains: ["Data and AI program vision", "Prioritization decisions", "Executive story", "Investor narrative"] },
  { name: "Sab Guerriero", role: "Executive Sponsor", domains: ["Go-to-market alignment", "Client story", "Platform narrative"] },
  { name: "Burke / Monica", role: "Revenue Leaders", domains: ["Rep / Recruiter story adoption", "Role-based dashboard requirements"] },
];

const METRICS = [
  {
    category: "Data Health",
    kpis: [
      { kpi: "% of reports backed by warehouse", target: "80% by end of Phase 2", liveDate: "Phase 2 complete", source: "Data warehouse metadata", status: "not-live" },
      { kpi: "Data quality scorecard avg", target: "85+", liveDate: "Phase 2 Week 4", source: "Weekly quality scorecard", status: "not-live" },
      { kpi: "# of active Excel reports replaced", target: "All P0/P1 by Phase 3", liveDate: "Phase 2", source: "30-Day Tracker", status: "in-progress" },
      { kpi: "# of systems with defined single owner", target: "All 29 systems", liveDate: "End Phase 1", source: "Data Audit tab", status: "in-progress" },
    ],
  },
  {
    category: "Speed to Insight",
    kpis: [
      { kpi: "Time to produce Monthly Ops Report", target: "Under 2 hours automated", liveDate: "Phase 2 complete", source: "Manual measurement until automated", status: "not-live" },
      { kpi: "# of dashboards live per role", target: "All 5 roles by Phase 2", liveDate: "Phase 2", source: "Power BI usage report", status: "not-live" },
      { kpi: "# of manual data reconciliation incidents per week", target: "0", liveDate: "Phase 3", source: "Ops team weekly report", status: "not-live" },
    ],
  },
  {
    category: "Trust",
    kpis: [
      { kpi: "Leader trust survey score per data domain", target: "High across all P0 systems", liveDate: "Phase 2 - survey at kickoff and quarterly", source: "Quarterly trust survey", status: "not-live" },
      { kpi: "# of conflicting metric definitions", target: "0", liveDate: "End Phase 1", source: "Metric definitions log", status: "in-progress" },
      { kpi: "# of data quality exceptions per week", target: "Trending to 0 by Phase 3", liveDate: "Phase 2 Week 4", source: "Quality scorecard", status: "not-live" },
    ],
  },
  {
    category: "AI Readiness",
    kpis: [
      { kpi: "% of Semantic Layer KPIs defined", target: "100% before AI layer launch", liveDate: "Phase 3 complete", source: "Semantic layer catalog", status: "not-live" },
      { kpi: "# of data sources connected to governed API gateway", target: "All P0/P1 sources", liveDate: "Phase 2", source: "Integration layer monitoring", status: "not-live" },
      { kpi: "Data classification completion", target: "100% of fields classified", liveDate: "Phase 3", source: "Data catalog", status: "not-live" },
    ],
  },
  {
    category: "AI Program Success",
    kpis: [
      { kpi: "Agentic Day Planner pilot open rate", target: "70%+ within first 2 weeks", liveDate: "Dec 2026 pilot launch", source: "Outlook analytics", status: "not-live" },
      { kpi: "Pilot action rate", target: "3+ recommendations acted on per day", liveDate: "Dec 2026 pilot launch", source: "Bullhorn activity tracking", status: "not-live" },
      { kpi: "User feedback score at 30-day review", target: "80%+ positive", liveDate: "Jan 2027", source: "Pilot survey", status: "not-live" },
    ],
  },
  {
    category: "Business Outcomes",
    kpis: [
      { kpi: "Reduction in decision-making cycle time", target: "Measurable by Phase 3", liveDate: "Phase 3", source: "Executive survey", status: "not-live" },
      { kpi: "CIM readiness score", target: "Investor-ready by Q2 2027", liveDate: "Q2 2027", source: "CIM readiness assessment", status: "not-live" },
      { kpi: "# of investor-ready story frameworks published", target: "All 9 by Phase 3", liveDate: "Phase 3 complete", source: "BI tool", status: "not-live" },
    ],
  },
];

function statusColor(s) {
  if (s === "done") return C.green;
  if (s === "in-progress") return C.orange;
  if (s === "not-ready") return C.red;
  return "#9ca3af";
}
function statusLabel(s) {
  if (s === "done") return "Done";
  if (s === "in-progress") return "In Progress";
  if (s === "not-ready") return "Not Ready";
  return "Not Started";
}

function TrustBadge({ v }) {
  const map = { high: [C.green, "#d4edda"], medium: ["#856404", "#fff3cd"], low: [C.red, "#f8d7da"], "n/a": ["#6b7280", "#f3f4f6"] };
  const [color, bg] = map[v] || map["n/a"];
  return <span style={{ background: bg, color, fontSize: 11, padding: "2px 8px", borderRadius: 4, fontWeight: 600 }}>{v}</span>;
}

function ActionBadge({ v }) {
  const map = { keep: ["#155724", "#d4edda"], fix: ["#856404", "#fff3cd"], migrate: ["#004085", "#cce5ff"], replace: ["#721c24", "#f8d7da"], evaluate: ["#495057", "#e9ecef"] };
  const [color, bg] = map[v] || map.evaluate;
  return <span style={{ background: bg, color, fontSize: 11, padding: "2px 8px", borderRadius: 4, fontWeight: 600, textTransform: "capitalize" }}>{v}</span>;
}

function Card({ children, style }) {
  return <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: "14px 16px", ...style }}>{children}</div>;
}

function SLabel({ text }) {
  return <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>{text}</div>;
}

function SessionBlock({ session, onNavigate }) {
  const [open, setOpen] = useState(false);
  const typeColor = { education: C.purple, working: C.blue, exec: C.gold, break: "#9ca3af" };
  const typeLabel = { education: "FOUNDATION", working: "WORKING SESSION", exec: "EXECUTIVE", break: "BREAK" };

  if (session.type === "break") {
    return (
      <div style={{ display: "flex", gap: 12, padding: "6px 0", borderBottom: "1px solid " + C.border, alignItems: "center" }}>
        <div style={{ width: 90, fontSize: 11, color: "#9ca3af", flexShrink: 0 }}>{session.time}</div>
        <div style={{ fontSize: 12, color: "#9ca3af", fontStyle: "italic" }}>{session.block}</div>
      </div>
    );
  }

  const color = typeColor[session.type] || C.blue;

  return (
    <div style={{ background: C.white, borderTop: "1px solid " + C.border, borderRight: "1px solid " + C.border, borderBottom: "1px solid " + C.border, borderLeft: "4px solid " + color, borderRadius: 8, marginBottom: 8, overflow: "hidden" }}>
      <div onClick={function() { setOpen(!open); }} style={{ padding: "12px 14px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3, flexWrap: "wrap" }}>
            <span style={{ fontSize: 10, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: 0.5 }}>{typeLabel[session.type]}</span>
            <span style={{ fontSize: 11, color: "#9ca3af" }}>{session.time}</span>
            {session.captureTab && (
              <span style={{ fontSize: 10, background: C.gold + "22", color: C.gold, padding: "1px 6px", borderRadius: 3, fontWeight: 700 }}>LIVE CAPTURE</span>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {session.sessionNum && <span style={{ fontSize: 11, fontWeight: 700, color: color, background: color + "22", padding: "1px 7px", borderRadius: 3, flexShrink: 0 }}>{session.sessionNum}</span>}
            <div style={{ fontWeight: 700, fontSize: 13 }}>{session.block}</div>
          </div>
          {session.owner && <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>Owner: {session.owner}</div>}
        </div>
        <span style={{ color: "#9ca3af", fontSize: 14, fontWeight: 700, flexShrink: 0 }}>{open ? "−" : "+"}</span>
      </div>

      {open && (
        <div style={{ padding: "0 14px 14px" }}>
          {session.purpose && <div style={{ fontSize: 12, color: C.muted, marginBottom: 10, fontStyle: "italic", lineHeight: 1.5 }}>{session.purpose}</div>}

          {session.items.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", marginBottom: 6 }}>Agenda Items</div>
              {session.items.map(function(item, i) {
                const isSuccess = item.includes("SUCCESS");
                const isChange = item.includes("CHANGE MANAGEMENT");
                return (
                  <div key={i} style={{ fontSize: 12, color: isSuccess ? C.gold : isChange ? C.purple : C.text, marginBottom: 4, paddingLeft: 10, borderLeft: "2px solid " + (isSuccess ? C.gold : isChange ? C.purple : C.border), lineHeight: 1.5, fontWeight: isSuccess || isChange ? 600 : 400 }}>
                    {item}
                  </div>
                );
              })}
            </div>
          )}

          {session.output && (
            <div style={{ background: "#f0f9ff", color: "#0369a1", padding: "8px 10px", borderRadius: 6, fontSize: 12, marginBottom: 10, lineHeight: 1.5 }}>
              <strong>Output:</strong> {session.output}
            </div>
          )}

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {session.presFile && (
              <a href={DRAFT_MATERIALS_BASE + session.presFile} target="_blank" rel="noopener noreferrer"
                style={{ fontSize: 11, padding: "4px 12px", background: C.dark, color: C.white, borderRadius: 4, textDecoration: "none", fontWeight: 600 }}>
                📊 View Presentation
              </a>
            )}
            {session.facFile && (
              <a href={DRAFT_MATERIALS_BASE + session.facFile} target="_blank" rel="noopener noreferrer"
                style={{ fontSize: 11, padding: "4px 12px", background: "#f3f4f6", color: C.dark, borderRadius: 4, textDecoration: "none", fontWeight: 600 }}>
                📋 Facilitator Guide
              </a>
            )}
            {session.captureTab && (
              <button onClick={function() { onNavigate(session.captureTab); }}
                style={{ fontSize: 11, padding: "4px 12px", background: C.gold, color: C.dark, borderRadius: 4, border: "none", cursor: "pointer", fontWeight: 700 }}>
                ▶ Open {session.captureTab}
              </button>
            )}
          </div>

          {session.preRead && session.preRead.length > 0 && (
            <div style={{ marginTop: 10, padding: "8px 10px", background: C.yellowBg, borderRadius: 6 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#92400e", marginBottom: 4, textTransform: "uppercase" }}>Pre-Read</div>
              {session.preRead.map(function(pr, i) {
                return <div key={i} style={{ fontSize: 11, color: "#78350f" }}>{pr}</div>;
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── METRICS COMPUTATION ENGINE ──────────────────────────────────────────────

const STATUS_META = {
  "live":     { label: "Live",         color: "#27ae60", bg: "#d1fae5" },
  "tracking": { label: "Tracking",     color: "#e67e22", bg: "#fef3c7" },
  "not-live": { label: "Not yet live", color: "#9ca3af", bg: "#f3f4f6" },
};

const SOURCE_TAB_LINKS = {
  "Readiness Capture":      "Readiness Capture",
  "Use Case Capture":       "Use Case Capture",
  "Story Capture":          "Story Capture",
  "Pilot Planning Capture": "Pilot Planning Capture",
  "Data Platform Capture":  "Data Platform Capture",
  "Governance Capture":     "Governance Capture",
  "30-Day Tracker":         "Status",
  "Data Audit":             "Data Audit",
};

// Compute a live value from a source key + available data sources
// Returns { value, display, hasLive } or null if source not ready
function computeLiveValue(sourceKey, tasks, s3, s4, s6, s7, s9) {
  if (!sourceKey) return null;

  // ── 30-Day Tracker sources
  if (sourceKey === "tracker:data_systems_done") {
    if (!tasks || !tasks.length) return null;
    const done = tasks.filter(function(t) { return t.track === "Data and Systems" && t.status === "done"; }).length;
    const total = tasks.filter(function(t) { return t.track === "Data and Systems"; }).length;
    return { value: done, display: done + " of " + total + " done", hasLive: true };
  }
  if (sourceKey === "tracker:metric_defs_status") {
    if (!tasks || !tasks.length) return null;
    const task = tasks.find(function(t) { return t.task && t.task.toLowerCase().includes("metric definition"); });
    if (!task) return null;
    const done = task.status === "done";
    return { value: done ? 0 : 1, display: done ? "0 conflicts (resolved)" : "Active conflicts (" + task.status + ")", hasLive: true };
  }
  if (sourceKey === "tracker:data_source_done") {
    if (!tasks || !tasks.length) return null;
    const task = tasks.find(function(t) { return t.task && t.task.toLowerCase().includes("data source tracker"); });
    if (!task) return null;
    return { value: task.status, display: task.status, hasLive: true };
  }

  // ── Readiness Capture (s3) sources
  if (sourceKey === "s3:avg_score") {
    if (!s3) return null;
    const dims = ["strategy","data","technology","talent","governance","usecase"];
    const scores = dims.map(function(d) { return s3[d] && s3[d].score ? s3[d].score : 0; });
    const scored = scores.filter(function(s) { return s > 0; });
    if (!scored.length) return null;
    const avg = (scored.reduce(function(a, b) { return a + b; }, 0) / scored.length).toFixed(1);
    return { value: avg, display: avg + " avg (" + scored.length + "/6 scored)", hasLive: true };
  }
  if (sourceKey === "s3:gaps_assigned") {
    if (!s3) return null;
    const dims = ["strategy","data","technology","talent","governance","usecase"];
    const needsGap = dims.filter(function(d) { return s3[d] && s3[d].score > 0 && s3[d].score < 4; });
    const assigned = needsGap.filter(function(d) { return s3[d] && s3[d].gap && s3[d].owner; });
    if (!needsGap.length) return null;
    return { value: assigned.length, display: assigned.length + " of " + needsGap.length + " gaps assigned", hasLive: true };
  }

  // ── Use Case Capture (s4) sources
  if (sourceKey === "s4:scored_count") {
    if (!s4) return null;
    const ids = ["dayplanner","opsreport","clientexp","retention","candmatch","revcast","poburndown","pipeline","acctstory","ebitda","contactchg","roireport"];
    const scored = ids.filter(function(id) { return s4[id] && ((s4[id].bv || 0) + (s4[id].dr || 0) + (s4[id].cx || 0)) > 0; }).length;
    if (!scored) return null;
    return { value: scored, display: scored + " of 12 scored", hasLive: true };
  }
  if (sourceKey === "s4:phase2_owned") {
    if (!s4) return null;
    const ids = ["dayplanner","opsreport","clientexp","retention","candmatch","revcast","poburndown","pipeline","acctstory","ebitda","contactchg","roireport"];
    const p2owned = ids.filter(function(id) { return s4[id] && s4[id].phase === "Phase 2" && s4[id].owner; }).length;
    if (!p2owned && !ids.some(function(id) { return s4[id] && s4[id].phase === "Phase 2"; })) return null;
    return { value: p2owned, display: p2owned + " Phase 2 use cases with owner", hasLive: true };
  }

  // ── Story Capture (s9) sources
  if (sourceKey === "s9:p2_confirmed") {
    if (!s9) return null;
    const p2ids = ["s1","s2","s3","s7"];
    const confirmed = p2ids.filter(function(id) { return s9[id] && s9[id].status === "confirmed"; }).length;
    if (!p2ids.some(function(id) { return s9[id] && s9[id].status; })) return null;
    return { value: confirmed, display: confirmed + " of 4 Phase 2 stories confirmed", hasLive: true };
  }
  if (sourceKey === "s9:all_confirmed") {
    if (!s9) return null;
    const allids = ["s1","s2","s3","s4","s5","s6","s7","s8","s9"];
    const confirmed = allids.filter(function(id) { return s9[id] && s9[id].status === "confirmed"; }).length;
    if (!allids.some(function(id) { return s9[id] && s9[id].status; })) return null;
    return { value: confirmed, display: confirmed + " of 9 stories confirmed", hasLive: true };
  }
  if (sourceKey === "s9:p2_biz_owned") {
    if (!s9) return null;
    const p2ids = ["s1","s2","s3","s7"];
    const owned = p2ids.filter(function(id) { return s9[id] && s9[id].biz && !s9[id].biz.includes("TBD"); }).length;
    if (!p2ids.some(function(id) { return s9[id] && s9[id].biz; })) return null;
    return { value: owned, display: owned + " of 4 Phase 2 stories with business owner", hasLive: true };
  }

  // ── Pilot Planning Capture (s7) sources
  // Reads s7[id].threshold directly (flat-by-item-id), matching the list
  // block's storage convention post-migration. Was s7.metrics[id].threshold
  // before the S7 config-driven migration -- see CHAT_CONTEXT.md.
  if (sourceKey === "s7:open_rate_target") {
    if (!s7) return null;
    const m = s7["open_rate"];
    if (!m || !m.threshold) return null;
    return { value: m.threshold, display: "Target: " + m.threshold, hasLive: true };
  }
  if (sourceKey === "s7:action_rate_target") {
    if (!s7) return null;
    const m = s7["action_rate"];
    if (!m || !m.threshold) return null;
    return { value: m.threshold, display: "Target: " + m.threshold, hasLive: true };
  }
  if (sourceKey === "s7:feedback_target") {
    if (!s7) return null;
    const m = s7["feedback"];
    if (!m || !m.threshold) return null;
    return { value: m.threshold, display: "Target: " + m.threshold, hasLive: true };
  }

  // ── Data Platform Capture (s6) sources
  if (sourceKey === "s6:decisions_made") {
    if (!s6) return null;
    const decIds = ["etl","warehouse","bi","semantic"];
    const made = decIds.filter(function(id) { return s6[id] && s6[id].status && s6[id].status !== "Open"; }).length;
    if (!decIds.some(function(id) { return s6[id] && s6[id].status; })) return null;
    return { value: made, display: made + " of 4 decisions made", hasLive: true };
  }

  return null;
}

function MetricsTab({ setTab, projectConfig }) {
  const { instance, accounts } = useMsal();
  const [metrics, setMetrics] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [s3data, setS3data] = useState(null);
  const [s4data, setS4data] = useState(null);
  const [s6data, setS6data] = useState(null);
  const [s7data, setS7data] = useState(null);
  const [s9data, setS9data] = useState(null);

  useEffect(function() {
    if (!accounts || !accounts.length) { setLoading(false); return; }
    var tokenResp;
    instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] })
      .then(function(resp) {
        tokenResp = resp;
        return Promise.all([
          fetchMetrics(resp.accessToken, projectConfig),
          fetchPlatformTracker(resp.accessToken, projectConfig).catch(function() { return { tasks: [] }; }),
          fetchSummitData ? fetchSummitData(resp.accessToken, projectConfig).catch(function() { return {}; }) : Promise.resolve({}),
        ]);
      })
      .then(function(results) {
        var summitData = results[2] || {};
        setMetrics(results[0]);
        setTasks(results[1].tasks || []);
        if (summitData.s3) setS3data(summitData.s3);
        if (summitData.s4) setS4data(summitData.s4);
        if (summitData.s6) setS6data(summitData.s6);
        if (summitData.s7) setS7data(summitData.s7);
        if (summitData.s9) setS9data(summitData.s9);
        setLastUpdated(new Date());
        setLoading(false);
      })
      .catch(function(e) {
        setError(e.message);
        setLoading(false);
      });
  }, [instance, accounts, projectConfig]);

  if (loading) return <div style={{ padding: 40, textAlign: "center", color: "#6b7280" }}>Loading metrics from SharePoint...</div>;

  if (error) return (
    <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: 16, color: "#7f1d1d", fontSize: 13 }}>
      Could not load metrics. Check that the Metrics sheet exists in TCC_Status.xlsx. Error: {error}
    </div>
  );

  if (!metrics.length) return (
    <div style={{ background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 8, padding: 16, color: "#78350f", fontSize: 13 }}>
      No metrics found. Add a Metrics sheet to TCC_Status.xlsx with the column headers: Category, KPI, Target, Live Date, Source Tab, Source Notes, Status, Owner, Source Key.
    </div>
  );

  const total = metrics.reduce(function(s, m) { return s + m.kpis.length; }, 0);
  const live = metrics.reduce(function(s, m) { return s + m.kpis.filter(function(k) { return k.status === "live"; }).length; }, 0);
  const tracking = metrics.reduce(function(s, m) { return s + m.kpis.filter(function(k) { return k.status === "tracking"; }).length; }, 0);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          {total} metrics across {metrics.length} categories.
          {lastUpdated && " Last loaded " + lastUpdated.toLocaleTimeString() + "."}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#d1fae5", color: "#27ae60", fontWeight: 700 }}>{live} Live</span>
          <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#fef3c7", color: "#e67e22", fontWeight: 700 }}>{tracking} Tracking</span>
          <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: "#f3f4f6", color: "#9ca3af", fontWeight: 700 }}>{total - live - tracking} Not yet live</span>
        </div>
      </div>

      {metrics.map(function(group) {
        return (
          <div key={group.category} style={{ background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 8, marginBottom: 12, overflow: "hidden" }}>
            <div style={{ background: "#1a1a2e", padding: "8px 14px" }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "#c9a84c", textTransform: "uppercase", letterSpacing: 1 }}>{group.category}</span>
            </div>
            {group.kpis.map(function(kpi, i) {
              const sm = STATUS_META[kpi.status] || STATUS_META["not-live"];
              const linkedTab = SOURCE_TAB_LINKS[kpi.sourceTab];
              const isLast = i === group.kpis.length - 1;
              const liveVal = computeLiveValue(kpi.sourceKey, tasks, s3data, s4data, s6data, s7data, s9data);
              const hasLive = liveVal && liveVal.hasLive;

              return (
                <div key={kpi.kpi} style={{ display: "flex", gap: 12, padding: "12px 14px", borderBottom: isLast ? "none" : "1px solid #e5e7eb", alignItems: "flex-start" }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: hasLive ? "#27ae60" : sm.color, flexShrink: 0, marginTop: 5 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e", marginBottom: 4 }}>{kpi.kpi}</div>

                    {hasLive && (
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#d1fae522", border: "1px solid #27ae6044", borderRadius: 6, padding: "3px 10px", marginBottom: 6 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: "#27ae60" }}>Now: {liveVal.display}</span>
                      </div>
                    )}

                    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 11, marginBottom: 4 }}>
                      <span style={{ color: "#27ae60" }}>Target: {kpi.target}</span>
                      <span style={{ color: "#2980b9" }}>Live: {kpi.liveDate}</span>
                      {kpi.owner && <span style={{ color: "#6b7280" }}>Owner: {kpi.owner}</span>}
                    </div>

                    {kpi.sourceNotes && !hasLive && (
                      <div style={{ fontSize: 11, color: "#6b7280", fontStyle: "italic", marginBottom: 4 }}>{kpi.sourceNotes}</div>
                    )}

                    {linkedTab && (
                      <button onClick={function() { setTab(linkedTab); }}
                        style={{ fontSize: 11, color: "#2980b9", background: "none", border: "1px solid #2980b922", borderRadius: 4, padding: "2px 8px", cursor: "pointer", marginTop: 2 }}>
                        → View {kpi.sourceTab}
                      </button>
                    )}
                  </div>

                  <span style={{ fontSize: 10, padding: "3px 10px", borderRadius: 10, background: hasLive ? "#d1fae5" : sm.bg, color: hasLive ? "#27ae60" : sm.color, fontWeight: 700, whiteSpace: "nowrap", flexShrink: 0 }}>
                    {hasLive ? "Live" : sm.label}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}

      <div style={{ background: "#1a1a2e", borderRadius: 8, padding: "12px 14px" }}>
        <div style={{ fontSize: 11, color: "#c9a84c", fontWeight: 700, marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>The 2027 Test</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
          {[["CIM Ready", "Every investor metric traces to a single auditable source with full lineage."], ["AI Ready", "Semantic Layer complete. AI has governed access. No raw system connections."], ["Operationally Ready", "No executive spends time reconciling data before a decision."], ["$500M Platform Story", "All 9 story frameworks published. Investor narrative backed by clean, consistent data."]].map(function(arr) {
            return (
              <div key={arr[0]} style={{ borderLeft: "3px solid #c9a84c", paddingLeft: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#c9a84c", marginBottom: 3 }}>{arr[0]}</div>
                <div style={{ fontSize: 11, color: "#9ca3af", lineHeight: 1.5 }}>{arr[1]}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  // Domain detection - must be before hooks but return happens after all hooks
  const hostname = window.location.hostname;
  const isTkPortal = hostname === "tk.tripleco.com" || hostname === "tk.localhost";

  // Dynamic project config - loads from API for non-TCC projects
  const { config: projectConfig, loading: configLoading, error: configError, pathId } = useProjectConfig();

  // Destructure config or fall back to TCC static config
  const NAV = (projectConfig && projectConfig.NAV) || TCC_NAV;
  const PROJECT_META = (projectConfig && projectConfig.PROJECT_META) || TCC_PROJECT_META;
  const PROJECT_PERMISSIONS = (projectConfig && projectConfig.PROJECT_PERMISSIONS) || TCC_PROJECT_PERMISSIONS;
  const SUMMIT_SESSIONS = (projectConfig && projectConfig.SUMMIT_SESSIONS) || TCC_SUMMIT_SESSIONS;

  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [orgToken, setOrgToken] = useState(null);
  const SESSION_KEY = 'tk_guest_session';
  const savedGuest = (() => { try { return JSON.parse(sessionStorage.getItem(SESSION_KEY)); } catch(e) { return null; } })();
  const [guestUser, setGuestUser] = useState(savedGuest);
  const [showGuestForm, setShowGuestForm] = useState(false);
  const [guestEmailInput, setGuestEmailInput] = useState('');
  const [guestError, setGuestError] = useState('');
  const getInitialTab = function() {
  var p = new URLSearchParams(window.location.search).get('tab');
  return p || "Status";
};
const [tab, _setTab] = useState(getInitialTab);
  const setTab = function(t) {
    _setTab(t);
    var u = new URL(window.location.href);
    u.searchParams.set("tab", t);
    window.history.pushState({}, "", u.toString());
  };

  // Sync URL when tab changes
  useEffect(function() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('tab') !== tab) {
      url.searchParams.set('tab', tab);
      window.history.replaceState({ tab: tab }, '', url.toString());
    }
  }, [tab]);

  // Handle browser back/forward
  useEffect(function() {
    function onPop(e) {
      var p = new URLSearchParams(window.location.search).get('tab');
      if (p) _setTab(p);
    }
    window.addEventListener('popstate', onPop);
    return function() { window.removeEventListener('popstate', onPop); };
  }, []);
  const [auditFilter, setAuditFilter] = useState("all");
  const [summitDay, setSummitDay] = useState("Day 1");
  const [platformCounts, setPlatformCounts] = useState({ done: 0, inProg: 0, notStarted: 0, atRisk: 0, total: 0, currentPhase: "Phase 1", phaseProgress: 0 });

  function handleLogin() {
    instance.loginPopup(loginRequest).catch(function(e) { if (e.errorCode !== "user_cancelled") console.error(e); });
  }
  function handleLogout() {
    instance.logoutPopup();
  }

  // Permission system - resolves AD groups + user overrides
  const perms = usePermissions(PROJECT_PERMISSIONS, guestUser ? guestUser.email : null);

  // Org directory token: acquired only after usePermissions' own silent
  // acquisition (inside usePermissions.js) has settled, not concurrently
  // with it. Firing both at once on mount collided in MSAL (observed as
  // a `block_iframe_reload` console warning), which silently left
  // orgToken null forever -- every owner dropdown ran on its static
  // fallback, every session, with no visible error anywhere.
  useEffect(function () {
    if (!accounts || !accounts.length) return;
    if (perms.loading) return;
    instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] })
      .then(function (resp) { setOrgToken(resp.accessToken); })
      .catch(function () { /* leave orgToken null -- OrgDirectoryProvider treats that as "no directory available", falls back everywhere */ });
  }, [instance, accounts, perms.loading]);

  // Backward compatible - tabs that just need auth use canAccessTab
  function canSee(tabName) {
    return perms.canAccessTab(tabName);
  }

  const done = platformCounts.done;
  const inProg = platformCounts.inProg;
  const notStarted = platformCounts.notStarted;
  const atRisk = platformCounts.atRisk;

  const filtered = auditFilter === "all" ? SOURCES : SOURCES.filter(function(s) { return s.action === auditFilter; });
  const currentPhaseLabel = platformCounts.currentPhase.split(" - ")[0] || "Phase 1";

  function navigateToTab(tabName) {
    setTab(tabName);
    window.scrollTo(0, 0);
    var url = new URL(window.location.href);
    url.searchParams.set('tab', tabName);
    window.history.pushState({ tab: tabName }, '', url.toString());
  }

  // Domain-based routing - after all hooks (React rules of hooks requirement)
  // Domain/path routing
  const pathname = window.location.pathname;
  const tkProjectPath = isTkPortal && pathname !== "/" && pathname !== "" ? pathname : null;

  // /docs is a reserved, portal-level route - not tied to any project.
  // Checked before the project-path branch below so "docs" is never treated
  // as a project id.
  if (isTkPortal && (pathname === "/docs" || pathname.startsWith("/docs/"))) {
    document.title = "TrapperKeeper Docs";
    return <DocsSection />;
  }

  // /consent-preview used to be a React route here (see CHAT_CONTEXT.md).
  // It's now a plain static file served directly by nginx (legal/consent-
  // preview.html, same pattern as /privacy and /terms) so a JS-less fetch
  // -- including Twilio's automated compliance crawler -- sees real content
  // instead of an empty <div id="root">. nginx's exact-match location block
  // wins before any request reaches this app, so this route is deliberately
  // gone from here, not redirected.

  // tk.tripleco.com root -> project selector
  if (isTkPortal && !tkProjectPath) {
    document.title = "TrapperKeeper";
    return <ProjectSelector />;
  }

  // tk.tripleco.com/projectid OR subdomain.tripleco.com -> full project app
  // Show loading while config fetches
  if (tkProjectPath || (!isTkPortal && hostname !== "datamvps.tripleco.com" && hostname !== "localhost")) {
    if (configLoading) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui", color: "#6b7280" }}>
          Loading project...
        </div>
      );
    }
    if (configError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "system-ui" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>🔍</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", marginBottom: 8 }}>Project not found</div>
          <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 24 }}>{configError}</div>
          <a href="https://tk.tripleco.com" style={{ padding: "10px 24px", background: "#1a1a2e", color: "#c9a84c", borderRadius: 6, textDecoration: "none", fontSize: 13, fontWeight: 700 }}>
            View all projects
          </a>
        </div>
      );
    }
    // Config loaded - fall through to render the full app with dynamic config
    document.title = PROJECT_META.name || "TrapperKeeper";
  } else {
    document.title = "TCC Data Platform";
  }

  return (
    <OrgDirectoryProvider accessToken={orgToken}>
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", color: C.dark, minHeight: "100vh", background: C.surface, fontSize: 13 }}>

      <div style={{ background: C.dark, color: C.white, padding: "0" }}>
        <div style={{ background: C.white, padding: "8px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <a href="https://tk.tripleco.com" style={{ cursor: "pointer" }}>
            <img src="/TCC-logo.png" alt="Triple Crown" style={{ height: 40, display: "block" }} />
          </a>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: 1, fontWeight: 600 }}>CONFIDENTIAL</div>
        </div>
        <div style={{ padding: "12px 24px", display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{PROJECT_META.name || "Data and Intelligence Platform"}</div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>{PROJECT_META.subtitle || ""}</div>
          </div>
          <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ borderRight: "1px solid #ffffff22", paddingRight: 14 }}>
              <div style={{ fontSize: 9, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>{platformCounts.currentPhase || "30-Day Tracker"}</div>
              <div style={{ display: "flex", gap: 10 }}>
                {[[done, "Done", C.green], [inProg, "In Progress", C.orange], [notStarted, "Not Started", "#9ca3af"], [atRisk, "At Risk", C.red]].map(function(arr) {
                  return (
                    <div key={arr[1]} style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 16, fontWeight: 700, color: arr[2] }}>{arr[0]}</div>
                      <div style={{ fontSize: 9, color: "#9ca3af" }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 9, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>Overall Progress</div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 80, height: 6, background: "#ffffff22", borderRadius: 3, overflow: "hidden" }}>
                  <div style={{ width: platformCounts.phaseProgress + "%", height: "100%", background: C.gold, borderRadius: 3, transition: "width 0.4s" }} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 700, color: C.gold }}>{platformCounts.phaseProgress}%</span>
              </div>
            </div>
            {(isAuthenticated || guestUser) ? (
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, color: C.gold, fontWeight: 700 }}>{accounts[0]?.name}</div>
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>{accounts[0]?.username}</div>
                </div>
                <button onClick={handleLogout} style={{ padding: "6px 14px", background: "transparent", border: "1px solid " + C.gold, color: C.gold, borderRadius: 4, fontSize: 12, cursor: "pointer", fontWeight: 600 }}>Sign Out</button>
              </div>
            ) : (
              <button onClick={handleLogin} style={{ padding: "6px 14px", background: C.gold, border: "none", color: C.dark, borderRadius: 4, fontSize: 12, cursor: "pointer", fontWeight: 700 }}>Sign In with TCC</button>
            )}
            {!isAuthenticated && !guestUser && (
              <div style={{ marginLeft: 10 }}>
                {!showGuestForm ? (
                  <button onClick={function() { setShowGuestForm(true); }}
                    style={{ fontSize: 11, color: C.muted, background: "none", border: "none", cursor: "pointer", textDecoration: "underline", padding: 0 }}>
                    Invited guest?
                  </button>
                ) : (
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input value={guestEmailInput} onChange={function(e) { setGuestEmailInput(e.target.value); }}
                      placeholder="your email address"
                      style={{ fontSize: 11, padding: "4px 8px", borderRadius: 4, border: "1px solid " + C.border, width: 170 }} />
                    <button onClick={function() {
                      var match = BYPASS_USERS.find(function(u) { return u.email.toLowerCase() === guestEmailInput.trim().toLowerCase(); });
                      if (match) { sessionStorage.setItem("tk_guest", JSON.stringify(match)); setGuestUser(match); }
                      else { alert("Email not found. Contact dan@tripleco.com for access."); }
                    }} style={{ fontSize: 11, padding: "4px 10px", background: C.dark, color: C.gold, border: "none", borderRadius: 4, cursor: "pointer", fontWeight: 700 }}>
                      Access
                    </button>
                    <button onClick={function() { setShowGuestForm(false); setGuestEmailInput(""); }}
                      style={{ fontSize: 11, color: C.muted, background: "none", border: "none", cursor: "pointer", padding: "0 4px" }}>
                      ✕
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ background: C.white, borderBottom: "1px solid " + C.border, overflowX: "auto" }}>
        <div style={{ display: "flex", minWidth: "max-content", padding: "0 24px" }}>
          {NAV.map(function(n) {
            return (
              <button key={n} onClick={function() { setTab(n); }} style={{ padding: "10px 13px", fontSize: 12, fontWeight: tab === n ? 700 : 400, color: tab === n ? C.gold : C.muted, background: "none", border: "none", borderBottom: tab === n ? "2px solid " + C.gold : "2px solid transparent", cursor: "pointer", whiteSpace: "nowrap" }}>
                {n}
              </button>
            );
          })}
          <a href="https://tk.tripleco.com/docs" style={{ padding: "10px 13px", fontSize: 12, fontWeight: 400, color: C.muted, textDecoration: "none", whiteSpace: "nowrap" }}>
            Docs
          </a>
        </div>
      </div>

      <div style={{ padding: "20px 24px", maxWidth: 1080 }}>

        {tab === "Status" && <StatusTab onCountsUpdate={setPlatformCounts} projectConfig={PROJECT_META} />}



        {tab === "AI Summit" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ background: C.dark, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ fontWeight: 700, color: C.gold, marginBottom: 6 }}>Triple Crown AI and Data Intelligence Summit - June 25-26, 2026</div>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                {[["Duration", "2 Full Days"], ["Location", "TCC Austin Office"], ["Audience", "Full Cross-Functional Leadership"], ["Output", "ETL selected, use cases ranked, governance written, pilot planned, Phase 2 kicked off"]].map(function(arr) {
                  return (
                    <div key={arr[0]}>
                      <div style={{ fontSize: 10, color: "#9ca3af", textTransform: "uppercase", marginBottom: 2 }}>{arr[0]}</div>
                      <div style={{ fontSize: 12, color: C.white }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: C.dark, marginBottom: 12, textTransform: "uppercase", letterSpacing: 1 }}>Attendees</div>
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: C.green, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>In-Person - Both Days</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {[["Dave Smith","Executive Sponsor"],["Sab Guerriero","Co-Founder"],["Mike Dansby","Finance"],["Dan Frasco","Technology Lead"],["Martin Lopez","Data and Infrastructure"],["Vanessa Fucciani","BI and Analytics"],["Rachel Hopper","Change Management"],["Annae Varela","Operations"],["Kalynn Hudman","Operations"],["Sarah Fletcher","Operations"]].map(function(a) {
                    return (
                      <div key={a[0]} style={{ display: "flex", flexDirection: "column", background: C.light, borderRadius: 6, padding: "7px 12px", minWidth: 140 }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: C.dark }}>{a[0]}</span>
                        <span style={{ fontSize: 10, color: C.muted, marginTop: 1 }}>{a[1]}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ borderTop: "1px solid " + C.border, paddingTop: 10 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: C.orange, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Virtual - Contributing Ahead of Summit, Invited to Individual Sessions as Needed</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {[["Monica Wilkins","Business Development"],["Steven Burke","Business Development"],["Ronnie Maksymowski","Operations"],["Victoria Logan","Operations"]].map(function(a) {
                    return (
                      <div key={a[0]} style={{ display: "flex", flexDirection: "column", background: C.orange + "11", border: "1px solid " + C.orange + "33", borderRadius: 6, padding: "7px 12px", minWidth: 140 }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: C.dark }}>{a[0]}</span>
                        <span style={{ fontSize: 10, color: C.muted, marginTop: 1 }}>{a[1]}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div style={{ background: C.yellowBg, border: "1px solid " + C.yellow, borderRadius: 8, padding: "12px 14px", marginBottom: 16 }}>
              <div style={{ fontWeight: 700, color: "#92400e", marginBottom: 6 }}>Success Checkpoints - Targets: 40% revenue growth, zero headcount adds, 5 agents by July 2027</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10 }}>
                {[["Day 1 Morning", "Ratify guiding principles and specific success targets. Every person aligned before work begins."], ["Day 1 Close", "Checkpoint: decisions made today - do they move us toward the July 2027 targets?"], ["Day 2 Opening", "Checkpoint: revisit success targets, confirm Day 2 priorities and owners"], ["Summit Close", "Final checkpoint: did we produce what we committed to? Every open item has an owner."]].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ background: C.white, borderRadius: 6, padding: "8px 10px" }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "#92400e", marginBottom: 3 }}>{arr[0]}</div>
                      <div style={{ fontSize: 11, color: "#78350f" }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ display: "flex", gap: 0, marginBottom: 16, background: C.white, border: "1px solid " + C.border, borderRadius: 8, overflow: "hidden", width: "fit-content" }}>
              {["Day 1", "Day 2"].map(function(d) {
                return (
                  <button key={d} onClick={function() { setSummitDay(d); }} style={{ padding: "10px 24px", fontSize: 13, fontWeight: summitDay === d ? 700 : 400, color: summitDay === d ? C.white : C.muted, background: summitDay === d ? C.dark : C.white, border: "none", cursor: "pointer" }}>
                    {d === "Day 1" ? "Day 1 - Foundation and Assessment" : "Day 2 - Decisions and Execution"}
                  </button>
                );
              })}
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              {[["FOUNDATION", C.purple], ["WORKING SESSION", C.blue], ["EXECUTIVE", C.gold]].map(function(arr) {
                return <span key={arr[0]} style={{ fontSize: 11, fontWeight: 700, color: arr[1], background: arr[1] + "22", padding: "3px 10px", borderRadius: 4 }}>{arr[0]}</span>;
              })}
              <span style={{ fontSize: 11, fontWeight: 700, color: C.gold, background: C.gold + "22", padding: "3px 10px", borderRadius: 4 }}>LIVE CAPTURE = opens capture tab</span>
            </div>

            {summitDay === "Day 1" && SUMMIT_SESSIONS.day1.map(function(session) {
              return <SessionBlock key={session.num} session={session} onNavigate={navigateToTab} />;
            })}
            {summitDay === "Day 2" && SUMMIT_SESSIONS.day2.map(function(session) {
              return <SessionBlock key={session.num} session={session} onNavigate={navigateToTab} />;
            })}
          </div>
        ))}

        {tab === "AI Charter" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ background: C.dark, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ fontSize: 10, color: C.gold, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>Triple Crown Consulting - Confidential</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.white, marginBottom: 4 }}>TCC AI Charter</div>
              <div style={{ fontSize: 12, color: "#9ca3af" }}>A Framework for Responsible Agentic AI Adoption. Ratified at the June 2026 AI Summit.</div>
            </div>
            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: "16px", marginBottom: 14 }}>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: C.dark }}>"{GUIDING_PRINCIPLES.principle}"</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: C.green, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>We ARE doing this to</div>
                  {GUIDING_PRINCIPLES.doing.map(function(item) {
                    return <div key={item} style={{ display: "flex", gap: 8, marginBottom: 6, fontSize: 12, color: C.text }}><span style={{ color: C.green, fontWeight: 700, flexShrink: 0 }}>✓</span>{item}</div>;
                  })}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: C.red, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>We are NOT doing this to</div>
                  {GUIDING_PRINCIPLES.notDoing.map(function(item) {
                    return <div key={item} style={{ display: "flex", gap: 8, marginBottom: 6, fontSize: 12, color: C.text }}><span style={{ color: C.red, fontWeight: 700, flexShrink: 0 }}>✗</span>{item}</div>;
                  })}
                </div>
              </div>
            </div>
            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>Definition of Success - Target State: July 1, 2027</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10, marginBottom: 16 }}>
              {SUCCESS_TARGETS.map(function(t) {
                return (
                  <div key={t.metric} style={{ background: C.white, border: "1px solid " + C.border, borderTop: "3px solid " + t.color, borderRadius: 8, padding: "12px 14px" }}>
                    <div style={{ fontSize: 18, fontWeight: 700, color: t.color, marginBottom: 4 }}>{t.target}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.dark, marginBottom: 4 }}>{t.metric}</div>
                    <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>{t.detail}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>Change Management - Every Agent Deployment</div>
            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: 16, marginBottom: 14 }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10, marginBottom: 14 }}>
                {CHANGE_MGMT_STEPS.map(function(s) {
                  return (
                    <div key={s.num} style={{ padding: "10px 12px", background: "#f9fafb", borderRadius: 6, borderLeft: "3px solid " + C.purple }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: C.purple, marginBottom: 4 }}>{s.num} {s.title}</div>
                      <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>{s.desc}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ fontWeight: 700, fontSize: 13, color: C.dark, marginBottom: 10 }}>Resistance Patterns and Responses</div>
              {RESISTANCE_PATTERNS.map(function(r) {
                return (
                  <div key={r.pattern} style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12, marginBottom: 8, padding: "8px 10px", background: "#f9fafb", borderRadius: 6 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.orange }}>{r.pattern}</div>
                    <div style={{ fontSize: 12, color: C.text, lineHeight: 1.5 }}>{r.response}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ background: C.yellowBg, border: "1px solid " + C.yellow, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontWeight: 700, color: "#92400e", marginBottom: 8 }}>AI Governance - Who Owns What</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
                {[["Business Units", "Own the what and why", "Problem identification, success metrics, outcomes"], ["Transformation Office", "Owns the portfolio", "Capital allocation, stage-gating, cross-functional coordination"], ["IT and CoE", "Own the how and the guardrails", "Infrastructure, security, technical enablement"]].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ background: C.white, borderRadius: 6, padding: "10px 12px" }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: C.dark, marginBottom: 3 }}>{arr[0]}</div>
                      <div style={{ fontSize: 11, color: C.gold, fontWeight: 600, marginBottom: 4 }}>{arr[1]}</div>
                      <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.5 }}>{arr[2]}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}

        {tab === "AI Business Case" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ background: C.dark, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ fontSize: 10, color: C.gold, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>Financial Framework</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.white, marginBottom: 4 }}>AI Business Case and Cost Model</div>
              <div style={{ fontSize: 12, color: "#9ca3af" }}>ROM cost estimates, CBA framework, and ROI projections. Every agent deployment requires a CBA before build begins.</div>
            </div>

            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>Cost Model - How AI Agent Costs Work</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10, marginBottom: 16 }}>
              {[
                { category: "Build Cost", items: ["Engineering time: 40-200 hours per agent depending on complexity", "Prompt engineering and testing: 10-20% of build time", "Integration work: API connections, data access setup", "QA and pilot preparation: 20-40 hours"], color: C.blue },
                { category: "Infrastructure Cost", items: ["LLM API costs: token-based pricing. GPT-4o ~$0.005 per 1K tokens", "Agentic Day Planner estimate: ~500 tokens per user per day", "50 users = ~25K tokens/day = ~$0.125/day = ~$46/year", "Scale to 200 users: ~$185/year in LLM costs"], color: C.green },
                { category: "Ongoing Cost", items: ["Model monitoring and maintenance: 2-4 hours/month per agent", "Prompt updates as business rules change", "Data quality issues that surface from agent output", "User feedback loops and retraining"], color: C.orange },
                { category: "Change Management Cost", items: ["Training design and delivery: 8-16 hours per role group", "Champion recruitment and support: 4-8 hours", "Communication materials: 4-8 hours", "30/60/90 day review facilitation: 4 hours each"], color: C.purple },
              ].map(function(c) {
                return (
                  <div key={c.category} style={{ background: C.white, borderTop: "1px solid " + C.border, borderRight: "1px solid " + C.border, borderBottom: "1px solid " + C.border, borderLeft: "4px solid " + c.color, borderRadius: 8, padding: "12px 14px" }}>
                    <div style={{ fontWeight: 700, color: c.color, marginBottom: 8 }}>{c.category}</div>
                    {c.items.map(function(item) {
                      return <div key={item} style={{ fontSize: 11, color: C.text, marginBottom: 4, paddingLeft: 8, borderLeft: "2px solid " + C.border, lineHeight: 1.5 }}>{item}</div>;
                    })}
                  </div>
                );
              })}
            </div>

            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>CBA Framework - Required Before Every Agent Build</div>
            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 14 }}>
                {[
                  { label: "Revenue Impact", desc: "What revenue increase does this agent enable? More placements, faster cycle times, higher retention? Quantify in dollars.", color: C.green },
                  { label: "Cost Offset", desc: "What labor cost does this agent replace or avoid? How many hours per week does it save per user at what fully-loaded cost?", color: C.blue },
                  { label: "Net Benefit", desc: "Revenue impact + cost offset minus total cost of ownership. Must be positive within 12 months for approval.", color: C.gold },
                ].map(function(item) {
                  return (
                    <div key={item.label} style={{ padding: "12px 14px", background: "#f9fafb", borderRadius: 6, borderTop: "3px solid " + item.color }}>
                      <div style={{ fontWeight: 700, color: item.color, marginBottom: 6 }}>{item.label}</div>
                      <div style={{ fontSize: 12, color: C.text, lineHeight: 1.5 }}>{item.desc}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ background: C.yellowBg, borderRadius: 6, padding: "10px 14px", fontSize: 12, color: "#78350f" }}>
                <strong>Rule:</strong> No agent enters the design process without an approved CBA. Draft CBAs go to the governance body. Actuals vs model are reviewed at 30, 60, and 90 days post-launch.
              </div>
            </div>

            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>Phase 4 Agent Portfolio - ROM Estimates</div>
            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, overflow: "hidden", marginBottom: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 80px 80px 80px 100px", gap: 8, padding: "8px 14px", background: "#f3f4f6", fontSize: 11, fontWeight: 700, color: C.muted }}>
                <span>Agent</span><span>Build (hrs)</span><span>Infra/yr</span><span>Payback</span><span>Status</span>
              </div>
              {[
                { agent: "Agentic Day Planner", build: "80-120", infra: "~$200", payback: "< 30 days", status: "Proposed flagship pilot", color: C.gold },
                { agent: "Candidate Matching", build: "60-100", infra: "~$150", payback: "2-3 months", status: "Phase 4 Q1 2027", color: C.purple },
                { agent: "Monthly Ops Report Automation", build: "40-60", infra: "~$100", payback: "< 30 days", status: "Phase 4 Q1 2027", color: C.green },
                { agent: "Client Expansion Signals", build: "80-120", infra: "~$200", payback: "3-6 months", status: "Phase 4 Q1 2027", color: C.blue },
                { agent: "Revenue Forecasting", build: "100-160", infra: "~$300", payback: "Ongoing", status: "Phase 4 Q1 2027", color: C.orange },
                { agent: "EBITDA Trajectory Modeling", build: "80-120", infra: "~$200", payback: "Ongoing", status: "CIM Readiness Q2 2027", color: C.red },
              ].map(function(a, i) {
                return (
                  <div key={a.agent} style={{ display: "grid", gridTemplateColumns: "1fr 80px 80px 80px 100px", gap: 8, padding: "8px 14px", borderTop: "1px solid " + C.border, background: i % 2 === 0 ? C.white : "#f9fafb", alignItems: "center" }}>
                    <div style={{ fontSize: 12, color: C.dark, fontWeight: 500 }}>
                      <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: a.color, marginRight: 6, verticalAlign: "middle" }} />
                      {a.agent}
                    </div>
                    <span style={{ fontSize: 11, color: C.muted }}>{a.build}</span>
                    <span style={{ fontSize: 11, color: C.muted }}>{a.infra}</span>
                    <span style={{ fontSize: 11, color: C.green, fontWeight: 600 }}>{a.payback}</span>
                    <span style={{ fontSize: 10, color: a.color, fontWeight: 600 }}>{a.status}</span>
                  </div>
                );
              })}
            </div>

            <div style={{ background: C.dark, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontSize: 11, color: C.gold, fontWeight: 700, marginBottom: 8, textTransform: "uppercase" }}>The Business Case for the Platform (Pre-AI)</div>
              <div style={{ fontSize: 12, color: "#9ca3af", lineHeight: 1.6, marginBottom: 10 }}>
                The data platform (Phases 1-3) is not an AI cost. It is an infrastructure investment that pays for itself before a single AI agent launches.
                Every story framework, every clean dashboard, every automated report eliminates manual reconciliation time.
                The CIM readiness story alone - traced, auditable, investor-ready data - is worth multiples of the platform build cost at exit.
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10 }}>
                {[
                  ["Monthly Ops Report", "Taylor: 8 hrs/month saved. 96 hrs/year at $75 fully-loaded = $7,200/year per report automated."],
                  ["PO Burndown Analysis", "4 owners x 4 hrs/month = 192 hrs/year at $75 = $14,400/year automated."],
                  ["Executive Dashboard", "2 hrs/week in manual data pulls eliminated across 5 leaders = 520 hrs/year at $100 = $52,000/year."],
                  ["CIM Readiness", "Investor-ready data reduces due diligence timeline. At $500M exit, 1 week faster = material value."],
                ].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ borderLeft: "3px solid " + C.gold, paddingLeft: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: C.gold, marginBottom: 3 }}>{arr[0]}</div>
                      <div style={{ fontSize: 11, color: "#9ca3af", lineHeight: 1.5 }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}

        {tab === "Data Audit" && (!canSee(tab) ? <LockedTab /> : <DataAuditTab />)}

        {tab === "Architecture" && (!canSee(tab) ? <LockedTab /> : <ArchitectureTab />)}

        {tab === "AI Strategy" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ background: C.yellowBg, border: "1px solid " + C.yellow, borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
              <div style={{ fontWeight: 700, color: "#92400e", marginBottom: 4 }}>Current State Risk: Ungoverned AI Access</div>
              <div style={{ fontSize: 12, color: "#78350f", lineHeight: 1.5 }}>CData Connect AI pipes raw Bullhorn data directly into ChatGPT. No semantic layer. No access controls. No data classification. No audit trail. Replacement is in progress but not complete.</div>
            </div>
            {AI_STRATEGY_PHASES.map(function(s) {
              return (
                <div key={s.phase} style={{ background: C.white, borderTop: "1px solid " + C.border, borderRight: "1px solid " + C.border, borderBottom: "1px solid " + C.border, borderLeft: "4px solid " + s.color, borderRadius: 8, padding: "12px 14px", marginBottom: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: s.color, textTransform: "uppercase", marginBottom: 3 }}>{s.phase}</div>
                  <div style={{ fontWeight: 700, marginBottom: 8 }}>{s.title}</div>
                  {s.items.map(function(item) {
                    return <div key={item} style={{ fontSize: 12, color: C.text, marginBottom: 5, paddingLeft: 10, borderLeft: "2px solid " + C.border, lineHeight: 1.5 }}>{item}</div>;
                  })}
                </div>
              );
            })}
            <div style={{ background: C.dark, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontSize: 12, color: C.gold, fontWeight: 700, marginBottom: 8 }}>The Rule: AI Reads the Semantic Layer, Not the Systems</div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {[["Raw Bullhorn -> AI", "Current state. No definitions. No controls. Wrong answers.", C.red], ["Curated Warehouse -> AI", "Better but ungoverned. No single KPI definition.", C.orange], ["Semantic Layer -> AI", "Target state. Every answer traced to a defined metric with lineage.", C.green]].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ flex: "1 1 160px", borderLeft: "3px solid " + arr[2], paddingLeft: 10 }}>
                      <div style={{ fontSize: 12, color: arr[2], fontWeight: 700, marginBottom: 3 }}>{arr[0]}</div>
                      <div style={{ fontSize: 11, color: "#9ca3af", lineHeight: 1.5 }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}

        {tab === "Agentic Day Planner" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ background: C.dark, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ fontSize: 10, color: C.gold, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 4 }}>Flagship Phase 4 Pilot - Target: Dec 2026</div>
              <div style={{ fontWeight: 700, fontSize: 16, color: C.white, marginBottom: 6 }}>Agentic Day Planner</div>
              <div style={{ fontSize: 12, color: "#9ca3af", lineHeight: 1.6 }}>An AI agent that runs overnight and delivers a prioritized, personalized day plan to every recruiter and sales rep via Outlook before they start their day. No prompting. No configuration. Just a smarter start to every morning.</div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10, marginBottom: 16 }}>
              {[["Pilot Target", "Dec 2026", C.purple], ["Delivery", "Outlook - morning arrival", C.blue], ["Trigger", "Overnight automated run", C.green], ["Pilot Cohort", "Determined at summit", C.gold], ["User Action Required", "None", C.green], ["Full Rollout Gate", "30-day pilot review - Jan 2027", C.orange]].map(function(arr) {
                return (
                  <div key={arr[0]} style={{ background: C.white, borderTop: "1px solid " + C.border, borderRight: "1px solid " + C.border, borderBottom: "1px solid " + C.border, borderLeft: "4px solid " + arr[2], borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ fontSize: 10, color: "#9ca3af", fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>{arr[0]}</div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: arr[2] }}>{arr[1]}</div>
                  </div>
                );
              })}
            </div>

            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 10 }}>Data Signals - What the Agent Reads</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10 }}>
                {AGENTIC_SIGNALS.map(function(src) {
                  return (
                    <div key={src.source} style={{ background: C.white, borderTop: "1px solid " + C.border, borderRight: "1px solid " + C.border, borderBottom: "1px solid " + C.border, borderLeft: "4px solid " + src.color, borderRadius: 8, padding: "12px 14px" }}>
                      <div style={{ fontWeight: 700, color: src.color, marginBottom: 8 }}>{src.source}</div>
                      {src.signals.map(function(s) {
                        return <div key={s} style={{ fontSize: 12, color: C.text, marginBottom: 4, paddingLeft: 8, borderLeft: "2px solid " + C.border, lineHeight: 1.5 }}>{s}</div>;
                      })}
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ background: C.dark, borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: C.gold, fontWeight: 700, marginBottom: 8, textTransform: "uppercase" }}>Success Metrics - Pilot</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 10 }}>
                {[["Adoption", "Open rate above 70% within first 2 weeks"], ["Action Rate", "Users act on 3+ recommendations per day plan"], ["Activity Impact", "Measurable increase in Bullhorn logged activity vs pre-pilot baseline"], ["User Feedback", "Net positive from 80% of pilot cohort at 30-day review"], ["Data Quality Signal", "Agent surfaces data gaps - these become P0 cleanup items"], ["Time Saved", "Self-reported reduction in time spent deciding what to do each morning"]].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ borderLeft: "3px solid " + C.gold, paddingLeft: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: C.gold, marginBottom: 3 }}>{arr[0]}</div>
                      <div style={{ fontSize: 11, color: "#9ca3af", lineHeight: 1.5 }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ background: C.yellowBg, border: "1px solid " + C.yellow, borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontWeight: 700, color: "#92400e", marginBottom: 8 }}>Pilot planning happens at the summit.</div>
              <div style={{ fontSize: 12, color: "#78350f", marginBottom: 8 }}>Cohort, build timeline, success criteria, and owner assignments are captured live and stored in the Pilot Planning Capture tab.</div>
              <button onClick={function() { setTab("Pilot Planning Capture"); }} style={{ padding: "6px 14px", background: C.dark, color: C.gold, border: "none", borderRadius: 4, fontSize: 12, cursor: "pointer", fontWeight: 700 }}>Open Pilot Planning Capture</button>
            </div>

            <div style={{ fontWeight: 700, fontSize: 14, color: C.dark, marginBottom: 10 }}>Cost-Benefit Analysis - Agentic Day Planner</div>
            <div style={{ background: C.white, border: "1px solid " + C.border, borderRadius: 8, padding: 16, marginBottom: 14 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 14 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.red, marginBottom: 10, textTransform: "uppercase", letterSpacing: 1 }}>Costs - Year 1 ROM</div>
                  {[
                    ["Build", "80-120 engineering hours. One-time."],
                    ["LLM API", "50 users x 500 tokens/day x $0.005/1K = ~$46/year."],
                    ["Change Management", "Rachel: training, comms, champion program. ~40-60 hours."],
                    ["Monitoring", "2-4 hours/month ongoing. Model quality and feedback loop."],
                    ["Total Year 1 ROM", "~$15,000-25,000 fully loaded at market rates."],
                  ].map(function(row) {
                    return (
                      <div key={row[0]} style={{ display: "flex", gap: 10, marginBottom: 6, padding: "6px 8px", background: "#fef2f2", borderRadius: 4 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.red, width: 140, flexShrink: 0 }}>{row[0]}</span>
                        <span style={{ fontSize: 11, color: C.text }}>{row[1]}</span>
                      </div>
                    );
                  })}
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.green, marginBottom: 10, textTransform: "uppercase", letterSpacing: 1 }}>Benefits - Year 1 ROM</div>
                  {[
                    ["Time saved per user", "30-45 min/day on decision-making. 50 users x 30 min = 25 hrs/day."],
                    ["Annual time value", "25 hrs/day x 250 days x $75 fully-loaded = $468,750/year."],
                    ["Activity increase", "10% more Bullhorn activity across 50 recruiters compounds into placements."],
                    ["Placement uplift", "1 extra placement/recruiter/year x $8K avg spread x 50 = $400,000."],
                    ["Total Year 1 Benefit ROM", "~$400,000-870,000 depending on adoption rate."],
                  ].map(function(row) {
                    return (
                      <div key={row[0]} style={{ display: "flex", gap: 10, marginBottom: 6, padding: "6px 8px", background: "#d4edda", borderRadius: 4 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.green, width: 140, flexShrink: 0 }}>{row[0]}</span>
                        <span style={{ fontSize: 11, color: C.text }}>{row[1]}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ background: C.dark, borderRadius: 6, padding: "12px 14px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 10 }}>
                {[["Year 1 Cost ROM", "~$15K-25K", C.red], ["Year 1 Benefit ROM", "~$400K-870K", C.green], ["Payback Period", "< 30 days at 10% adoption", C.gold]].map(function(arr) {
                  return (
                    <div key={arr[0]} style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4 }}>{arr[0]}</div>
                      <div style={{ fontSize: 18, fontWeight: 700, color: arr[2] }}>{arr[1]}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11, color: C.muted, fontStyle: "italic" }}>
                ROM = Rough Order of Magnitude. Assumptions: 50 pilot users, $75 fully-loaded hourly cost, 30 min/day time savings, 10% activity lift at full rollout. Actuals vs model reviewed at 30, 60, and 90 days post-launch per the AI Charter CBA requirement.
              </div>
            </div>
          </div>
        ))}

        {tab === "Ownership" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ fontSize: 12, color: C.muted, marginBottom: 14 }}>Core ownership model. Final assignments confirmed at the summit and captured in Execution Capture.</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10, marginBottom: 14 }}>
              {OWNERS.map(function(o) {
                return (
                  <Card key={o.name}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: C.dark, color: C.gold, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, flexShrink: 0 }}>
                        {(o && o.name) ? o.name.split(" ").map(function(n) { return n[0]; }).join("").slice(0, 2) : "?"}
                      </div>
                      <div>
                        <div style={{ fontWeight: 700 }}>{o.name}</div>
                        <div style={{ fontSize: 11, color: C.muted }}>{o.role}</div>
                      </div>
                    </div>
                    {o.domains.map(function(d) {
                      return <div key={d} style={{ fontSize: 12, color: C.text, marginBottom: 3, paddingLeft: 8, borderLeft: "2px solid " + C.border }}>{d}</div>;
                    })}
                  </Card>
                );
              })}
            </div>
            <div style={{ background: C.yellowBg, border: "1px solid " + C.yellow, borderRadius: 6, padding: "10px 14px" }}>
              <div style={{ fontSize: 12, color: "#78350f" }}>Final workstream ownership is assigned live at the summit. Open Execution Capture to see current assignments.</div>
              <button onClick={function() { setTab("Execution Capture"); }} style={{ marginTop: 8, padding: "5px 12px", background: C.dark, color: C.gold, border: "none", borderRadius: 4, fontSize: 11, cursor: "pointer", fontWeight: 700 }}>Open Execution Capture</button>
            </div>
          </div>
        ))}

        {tab === "Metrics" && (!canSee(tab) ? <LockedTab /> : (
          <MetricsTab setTab={setTab} projectConfig={PROJECT_META} />
        ))}

        {tab === "New Hire Onboarding Tracker" && (!canSee(tab) ? <LockedTab /> : <OnboardingTracker />)}

        {tab === "SMS Notifications" && <ConsentForm />}

        {tab === "Readiness Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>AI Readiness Live Scoring</div>
              <div style={{ fontSize: 13, color: C.muted }}>Score each dimension 1-5 as a group. Gap owner and phase fields appear for scores below 4. Change management is a scored dimension. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={readinessCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Use Case Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Use Case Prioritization Live Scoring</div>
              <div style={{ fontSize: 13, color: C.muted }}>Score each use case on Business Value, Data Readiness, and Complexity. Rankings re-sort live as scores are entered. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={useCaseCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Data Platform Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Data Platform Tooling Decisions</div>
              <div style={{ fontSize: 13, color: C.muted }}>Record the four critical tooling decisions. These decisions unlock Phase 2. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={dataPlatformDecisionsCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Pilot Planning Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Agentic Day Planner Pilot Planning</div>
              <div style={{ fontSize: 13, color: C.muted }}>Capture pilot cohort, build timeline, success criteria, and owner assignments. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={pilotPlanningCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Governance Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>AI Governance and Change Management</div>
              <div style={{ fontSize: 13, color: C.muted }}>Capture governance guardrails and change management plan. Rachel Hopper owns change management. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={governanceCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Story Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Story Framework Owner Assignment</div>
              <div style={{ fontSize: 13, color: C.muted }}>Assign business owner and BI build owner to each story. Click status badge to cycle. Gold border = Phase 2 priority. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={storyFrameworkCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Execution Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Execution Planning and Ownership Register</div>
              <div style={{ fontSize: 13, color: C.muted }}>Confirm owner, phase, and due date for every workstream across all phases. Set the Phase 2 kickoff date. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={executionCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Current State Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Current State - Honest Assessment</div>
              <div style={{ fontSize: 13, color: C.muted }}>No sugarcoating. Capture the honest current state across 6 areas. The room must acknowledge each area before Phase 2 planning begins. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={currentStateCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Day 1 Wrap Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Day 1 Wrap - Decisions Log</div>
              <div style={{ fontSize: 13, color: C.muted }}>Day 1 closing session. Lock Day 1 decisions. Run success checkpoint against morning commitments. Capture open items carrying to Day 2. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={day1WrapCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Summit Close Capture" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>Summit Close - Final Commitments</div>
              <div style={{ fontSize: 13, color: C.muted }}>Final summit session. Every person leaves with their assignment. Lock all commitments. Run final success checkpoint. Build the complete action item register. Auto-saves to SharePoint.</div>
            </div>
            <GenericCaptureRenderer tabConfig={summitCloseCaptureConfig} projectConfig={projectConfig} />
          </div>
        ))}

        {tab === "Acceleration Capture" && (!canSee(tab) ? <LockedTab /> : (<AccelerationCapture />))}
        {tab === "Admin" && (!canSee(tab) ? <LockedTab /> : (
          <div>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 4 }}>TrapperKeeper Admin</div>
              <div style={{ fontSize: 13, color: C.muted }}>Project management, configuration, and platform administration. Access is controlled via ADMIN_ACL in server .env.</div>
            </div>
            <AdminTab />
          </div>
        ))}

        <Footer />
      </div>
    </div>
    </OrgDirectoryProvider>
  );
}
